import React, { useEffect, useState, useReducer, Fragment } from "react";
import PropTypes from "prop-types";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    FormControl,
    Typography, 
    Box,
} from "@mui/material";
import { I18n } from "aws-amplify/utils";
import dayjs from "dayjs";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Wheel from '@uiw/react-color-wheel';
import { hsvaToHex, hexToHsva } from '@uiw/color-convert';

function EditColorPopup({ isOpen, onClose, mainFormData, handleEditColorSubmit }) {
  // The colors are in hsva format (hue, saturation, value, alpha) and the text field is in hex format (#RRGGBB)
  // The color wheel is in hsva format and the text field is in hex format (#RRGGBB)
  const [hsva, setHsva] = useState({});
  const [wheelChanged, setWheelChanged] = useState(false);
  const [formData, setFormData] = useState({
    alarm_type_id: mainFormData.alarm_type_id,
    colour: mainFormData.colour,
  });

  // Updates the color wheel with the already selected color 
  useEffect(() => {
    setHsva(formData.colour);
  }, []);

  // When the color is chnged from the wheel it will update the text field
  useEffect(() => {
    if(wheelChanged){
      setFormData((currentState) => ({
        ...currentState,
        colour: hsvaToHex(hsva),
      }));
    }
  }, [hsva]);

  // When the color is changed from the text field it will update the wheel. If the hex is invalid it will not update the wheel
  useEffect(() => {
    if(formData.colour.length === 7 && (/^#([0-9A-Fa-f]{6})$/.test(formData.colour))){
      setHsva(hexToHsva(formData.colour));
    }
  },[formData.colour]);

  const handleChange = (event) => {
    setFormData((currentState) => ({
      ...currentState,
      [event.target.name]: event.target.value.toUpperCase(),
    }));
    setWheelChanged(false);
  };

  //
  const handleSaveColor = () => {
    handleEditColorSubmit(formData);
  }

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{I18n.get("Edit Color")}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Wheel 
          color={hsva} 
          onChange={(color) => {
            setHsva({ ...hsva, ...color.hsva }); 
            setWheelChanged(true)}
        } 
        />
        </Box>
        <Box style={{ width: '100%', height: 34, marginTop: 20, background: formData.colour }}/>
        <FormControl fullWidth margin="normal" className="custom-form-control">
            <TextField
            label={I18n.get("Color")}
            value={(formData.colour) || "#"}
            onChange={(event) => {handleChange(event)}}
            fullWidth
            margin="normal"
            name="colour"
            className="custom-text-field"
            error={formData.colour.length !== 7 || !(/^#([0-9A-Fa-f]{6})$/.test(formData.colour))}
            helperText={formData.colour.length !== 7 || !(/^#([0-9A-Fa-f]{6})$/.test(formData.colour)) ? I18n.get("Invalid color") : ""}
            />
        </FormControl>
      </DialogContent>
      <DialogActions sx={{ pt: 2 }}>
          <>
            <Button
              color="primary"
              onClick={onClose}
              style={{ marginLeft: "10px" }}
            >
              {I18n.get("Cancel")}
            </Button>
            <Button
              color="primary"
              onClick={handleSaveColor}
              disabled={
                formData.colour.length !== 7 || !(/^#([0-9A-Fa-f]{6})$/.test(formData.colour))
              }
            >
              {I18n.get("Save")}
            </Button>
          </>
      </DialogActions>
    </Dialog>
  );
}

EditColorPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default EditColorPopup;
